/**
 * BreadCrumb Component.
 * It helps to show the selected Topic in Breadcrumb with Separator.
 * It also provide `Change` link to go back and forth.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from './index';

class BreadCrumb extends Component {
  // Get Breadcrumb Items.
  getItems() {
    return (
      <ol className="breadcrumb">
        {this.props.items.map((name) => (
          <li key={name}>{name}</li>
        ))}
      </ol>
    );
  }

  // Get Change Link with Passing Track info as Props.
  getChangeLink() {
    return (
      <Link
        key="change-tree"
        id="change-tree"
        label={this.props.backLinkLabel}
        classNames="btn vx_btn-link change-tree"
        onClick={this.props.handleChange}
        trackLink={this.props.trackLink}
      />
    );
  }

  // Get Breadcrumb.
  getBreadCrumb() {
    return (
      <div className="bread-crumb">
        <div className="left-col col-xs-10 col-sm-10 col-md-10 col-lg-10">
          <p className="block-label">{this.props.blockLabel}</p>
          {this.getItems()}
        </div>
        <div className="right-col col-xs-2 col-sm-2 col-md-2 col-lg-2">{this.getChangeLink()}</div>
      </div>
    );
  }

  // Render the `BreadCrumb` Component.
  render() {
    return this.getBreadCrumb();
  }
}

// BreadCrumb Props Types.
BreadCrumb.propTypes = {
  // Simple Props.
  blockLabel: PropTypes.string.isRequired,
  backLinkLabel: PropTypes.string.isRequired,

  // Complex Props.
  items: PropTypes.arrayOf(PropTypes.string).isRequired,
  trackLink: PropTypes.shape({
    id: PropTypes.string,
    link: PropTypes.string,
  }).isRequired,

  // Method Props.
  handleChange: PropTypes.func.isRequired,
};

export default BreadCrumb;
